<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <p class="mb-4">
      Sorry, we are unable to accept changes to addresses with a unique ZIP Code<sup>™</sup> via MoversGuide Online at this time. Mail addressed to an addressee with a unique ZIP Code<sup>™</sup> cannot be forwarded. For more information on mail forwarding regulations, contact your local Postmaster.
    </p>
    <button
      ref="exit"
      class="c-btn--secondary mr-5 mb-5 sm:mb-0 m:mb-0 lg:mb-0 xl:mg-0"
      @click="reboot"
    >
      Exit
    </button>
    <router-link
      ref="editAddress"
      :to="editRoute"
      class="c-btn"
    >
      Re-enter Addresses
    </router-link>
  </main>
</template>

<script>
import { isDesktop } from '../utils/deviceType';
import pageView from '../mixins/pageView';

export default {
  name: 'ErrorOldUniqueZip',
  mixins: [pageView],
  computed: {
    editRoute() {
      return { name: !isDesktop() ? 'move-combined' : 'disclaimer' };
    },
  },
  mounted() {
    this.pageView();
  },
  methods: {
    reboot() {
      this.$deleteSession();
      this.$coa.reset();
      this.$router.replace({ name: 'disclaimer' });
    },
  },
};
</script>
